"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLineChartTooltipDataType = void 0;
var tslib_1 = require("tslib");
exports.getLineChartTooltipDataType = function (data, tooltipXVal, xScale) {
    var dataAtMouseLocation = [];
    data.forEach(function (d) {
        var values = d.values, rest = tslib_1.__rest(d, ["values"]);
        var currentTooltipValue = tslib_1.__assign(tslib_1.__assign({}, rest), { value: d.values.find(function (v) { return xScale(v.x) === xScale(tooltipXVal); }) });
        currentTooltipValue.value = d.values.find(function (v) { return xScale(v.x) === xScale(tooltipXVal); });
        dataAtMouseLocation.push(currentTooltipValue);
    });
    return dataAtMouseLocation;
};
